// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$(document).ready(function () {
    $(".play-button").hover(function () {
        $(".inner-overlay").css("background", "rgba(0,0,0,0.35)");
    });
    $(".play-button").mouseleave(function () {
        $(".inner-overlay").css("background", "rgba(0,0,0,0)");
    });
});

$('#vidModal').on('shown.bs.modal', function () {
  $('#vapewear-promo')[0].play();
})
$('#vidModal').on('hidden.bs.modal', function () {
  $('#vapewear-promo')[0].pause();
})

$(window).on('load resize', function () {
	var borWidth = $('body').width() / 1;
	$('.tri').css("border-left-width", borWidth);
});

/**
 * Element.requestFullScreen() polyfill
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!Element.prototype.requestFullscreen) {
	Element.prototype.requestFullscreen = Element.prototype.mozRequestFullscreen || Element.prototype.webkitRequestFullscreen || Element.prototype.msRequestFullscreen;
}

// Listen for clicks
document.addEventListener('click', function (event) {

	// Check if clicked element is a video thumbnail
	var videoId = event.target.getAttribute('data-video');
	if (!videoId) return;

	// Create iframe
	var iframe = document.createElement('div');
	iframe.innerHTML = '<p>x</p><iframe width="100%" height="553" src="https://www.youtube.com/embed/' + videoId + '?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
	var video = iframe.childNodes[1];

	// Replace the image with the video
	event.target.parentNode.replaceChild(video, event.target);

	// Enter fullscreen mode
	video.requestFullscreen();

}, false);

// More info buttons for shop archive page
$('.post-type-archive-product .post-865').append('	<a href="/product/starter-pack-black/" class="single_add_to_cart_button button alt">More Info</a>');

$('.post-type-archive-product .post-846').append('	<a href="/product/starter-pack-white/" class="single_add_to_cart_button button alt">More Info</a>');

$( ".woocommerce-notices-wrapper" ).addClass( "container" );



// WEBPACK FOOTER //
// ./scripts/main.js